import {
  Avatar,
  Button,
  Flex,
  Icon,
  Image,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  useColorMode,
  useToast,
  Box,
} from '@chakra-ui/react';
import { ItemContent } from 'components/menu/ItemContent';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import PropTypes from 'prop-types';
import React from 'react';
import './index.css';

// Import NotificationPanel
import NotificationPanel from '../Notifications/Notification'; // Add this line

// import navImage from 'assets/img/layout/Navbar.png';
import { MdNotificationsNone, MdInfoOutline } from 'react-icons/md';
import { IoMdMoon, IoMdSunny } from 'react-icons/io';
import { FaEthereum } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { MdLogout } from 'react-icons/md';
import { RiShieldUserLine } from 'react-icons/ri';
import routes from 'routes';
import LanguageToggle from 'components/Language';
import { useTranslation } from 'react-i18next';

export default function HeaderLinks(props) {
  const { secondary } = props;
  const { colorMode, toggleColorMode } = useColorMode();

  const navbarIcon = useColorModeValue('gray.400', 'white');
  const menuBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const textColorBrand = useColorModeValue('brand.700', 'brand.400');
  const ethColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');
  const ethBg = useColorModeValue('secondaryGray.300', 'navy.900');
  const ethBox = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );
  const borderButton = useColorModeValue('secondaryGray.500', 'whiteAlpha.200');
  const subTextColor = useColorModeValue('gray.600', 'gray.400');

  const toast = useToast();
  let user = JSON.parse(localStorage.getItem('user'));

  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      html: `<strong>${user.name?.toUpperCase()}</strong> (${
        user.role === 'schemeAdmin'
          ? 'OFFICE IN CHARGE (OIC)'
          : user.role === 'subDivisionalOfficer'
            ? 'SUB DIVISIONAL OFFICER'
            : user.role === 'projectOfficer'
              ? 'PROJECT OFFICER (PO)'
              : user.role === 'talukaUser'
                ? 'TEHSILDAR'
                : user.role === 'admin'
                  ? 'ADMIN'
                  : user.role?.toUpperCase()
      }) will be logged out.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#38A169',
      cancelButtonColor: '#E53E3E',
      confirmButtonText: 'Yes, log out!',
      customClass: {
        popup: 'chakra-ui-light',
        icon: 'custom-warning-icon',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');

        toast({
          title: `${user.name?.toUpperCase()} logged out.`,
          status: 'info',
          duration: 3000,
          isClosable: true,
        });

        setTimeout(() => {
          window.location.href = '/auth/sign-in';
        }, 500);
      }
    });
  };

  const { t } = useTranslation();

  const addFastTransitionCSS = () => {
    if (typeof document !== 'undefined') {
      const styleId = 'fast-theme-transition';
      if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
          .chakra-ui-light, .chakra-ui-dark {
            transition: background-color 0.15s ease, color 0.15s ease !important;
          }
          * {
            transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease !important;
          }
        `;
        document.head.appendChild(style);
      }
    }
  };

  React.useEffect(() => {
    addFastTransitionCSS();
  }, []);

  return (
    <Flex
      w="100%"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      bg={menuBg}
      p={2}
      borderRadius="25px"
      boxShadow={shadow}
      style={{ zIndex: '9999' }}
      gap={4}
      pl={4}
      pt={3}
    >
      <Flex
        w={{ base: '100%', md: 'auto' }}
        textAlign={{ base: 'center', md: 'left' }}
        justifyContent={{ base: 'center', md: 'center' }}
        gap={2}
        style={{
          animation: 'fadeIn 2s ease-in-out, slideIn 1s ease-out',
        }}
      >
        <Box textAlign={{ base: 'center', md: 'left' }} lineHeight="1.6">
          <Text as="h4" fontSize="16px" fontWeight="bold" color={textColor}>
            👋 {t('Hello')}, {user.name?.toUpperCase()}
          </Text>

          <Flex align="center" pl="6" gap="1">
            <Icon as={RiShieldUserLine} color={subTextColor} boxSize={4} />
            <Text
              as="p"
              fontSize="12px"
              fontWeight="medium"
              color={subTextColor}
            >
              {user.role === 'schemeAdmin'
                ? 'OFFICE IN CHARGE (OIC)'
                : user.role === 'subDivisionalOfficer'
                  ? 'SUB DIVISIONAL OFFICER (SDO)'
                  : user.role === 'talukaUser'
                    ? 'TEHSILDAR'
                    : user.role === 'admin'
                      ? 'ADMIN'
                      : user.role === 'projectOfficer'
                        ? 'PROJECT OFFICER (PO)'
                        : user.role?.toUpperCase()}
            </Text>
          </Flex>
        </Box>
      </Flex>

      <Flex
        w={{ sm: '100%', md: 'auto' }}
        alignItems="center"
        justifyContent="flex-end"
        flexWrap="wrap"
        gap={{ base: 1, md: 2 }} // Changed from 0 to 2
      >
        <SidebarResponsive routes={routes} />

        {/* Add Notification Panel Here */}
        <NotificationPanel />

        <Button
          variant="no-hover"
          bg="transparent"
          p="0px"
          minW="unset"
          minH="unset"
          h="18px"
          w="max-content"
          onClick={toggleColorMode}
          aria-label="Toggle theme"
          title={
            colorMode === 'light'
              ? 'Switch to dark mode'
              : 'Switch to light mode'
          }
        >
          <Icon
            me="10px"
            h="18px"
            w="18px"
            color={navbarIcon}
            as={colorMode === 'light' ? IoMdMoon : IoMdSunny}
          />
        </Button>

        {/* <Flex
          align="center"
          justify="flex-end"
          p={2}
          bg="gray.50"
          borderRadius="md"
          boxShadow="sm"
          w="fit-content"
        >
          <LanguageToggle />
        </Flex> */}

        <Menu>
          <MenuButton p="0px">
            <Avatar
              _hover={{ cursor: 'pointer' }}
              color="white"
              name={user?.name}
              bg="#11047A"
              size="sm"
              w="40px"
              h="40px"
            />
          </MenuButton>

          <MenuList
            boxShadow={shadow}
            p="0px"
            mt="10px"
            borderRadius="20px"
            bg={menuBg}
            border="none"
          >
            <Flex flexDirection="column" p="10px">
              <MenuItem
                icon={<MdLogout />}
                _hover={{ bg: 'red.50', color: 'red.500' }}
                _active={{ bg: 'red.100' }}
                _focus={{ boxShadow: 'none' }}
                color="red.500"
                fontWeight="600"
                fontSize="18px"
                borderRadius="8px"
                px="10px"
                py="6px"
                onClick={handleLogout}
              >
                {t('Logout')}
              </MenuItem>
            </Flex>
          </MenuList>
        </Menu>
      </Flex>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
